var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIosDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 19.2,
    height: 19.2,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60004 12.8C9.41312 12.8004 9.23197 12.7353 9.08804 12.616L4.28804 8.61599C3.94784 8.33322 3.90127 7.8282 4.18404 7.48799C4.46681 7.14779 4.97184 7.10122 5.31204 7.38399L9.60004 10.968L13.888 7.51199C14.0533 7.37778 14.2653 7.31498 14.477 7.3375C14.6887 7.36002 14.8827 7.46601 15.016 7.63199C15.1642 7.79828 15.2362 8.01878 15.215 8.24044C15.1937 8.46211 15.0811 8.66488 14.904 8.79999L10.104 12.664C9.95598 12.7644 9.77852 12.8123 9.60004 12.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIosDownward);
export default __webpack_public_path__ + "static/media/arrow-ios-downward.786c83dfd201d0d0633e470d83e39aed.svg";
export { ForwardRef as ReactComponent };